"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.facilityReducer = exports.clearFacility = exports.setFacility = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var facility_storage_1 = require("../../utils/facility-storage");
var initialState = {
    facility: (0, facility_storage_1.loadFacilitySession)(),
};
var facilitySlice = (0, toolkit_1.createSlice)({
    name: "facilitySlice",
    initialState: initialState,
    reducers: {
        setFacility: function (state, action) {
            state.facility = action.payload;
        },
        clearFacility: function (state) {
            state.facility = null;
        },
    },
});
exports.setFacility = (_a = facilitySlice.actions, _a.setFacility), exports.clearFacility = _a.clearFacility;
exports.facilityReducer = facilitySlice.reducer;
